"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../constants");
var utils_1 = require("../utils");
function normalizeSavedSearches(_a) {
    var data = _a.data, _b = _a.inputValue, inputValue = _b === void 0 ? '' : _b;
    if (!data)
        return [];
    return data.map(function (savedSearch) {
        var name = savedSearch.name, url = savedSearch.url;
        return {
            searchType: constants_1.SearchType.SavedSearch,
            text: name,
            highlightedText: (0, utils_1.highlightText)(name, inputValue),
            searchHash: url,
            href: "/cars/filters?cvnaid=".concat(url)
        };
    });
}
exports.default = normalizeSavedSearches;
//# sourceMappingURL=normalizeSavedSearches.js.map